import { eventsList } from '../../events/list';
import { initHttp } from '../../utils/http';
import { extendDeep } from '../../utils/utils';
import { addEvents } from '../decorators';
import { initFolders } from './folders';
import { initItem } from './item';
import { initItems } from './items';
import { defaultSettings } from './settings';
export function Vimeo(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(defaultSettings, userSettings);
  const http = initHttp();
  const folders = initFolders(settings, http);
  const items = initItems(settings, http);
  const item = initItem(settings, http);
  this.name = 'vimeo';
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.item = addEvents(this, eventsList.ITEM, item);
}